<template>
  <modal
    size="small"
    class="Modal__callToActionAutos"
    @close-modal="closeModal"
  >
    <div slot="content">
      <div class="Explicacao c-modal-autos__content">
        <div>
          <svg
            class="c-modal-autos__icone"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 89"
          >
            <defs />
            <path fill="#F2EDDA" d="M44.1.6L30.3 14.4v43.5H71V.6H44z" />
            <path
              fill="#F2EDDA"
              fill-rule="evenodd"
              d="M44.2.8c-.1-.5 5.1-.4 9-.5l9.5-.3 3.2.1h5.7v.5l.1 8.5v22.6c0 3 .2 5.3.3 7.4l-.3 8.8v4.8l-.1 4.1v1.6H71l-2.7.1-16.8.1h-22V58v-3.4l-.1-4.2c.2-7.4.2-16 0-22.6V23c0-2.8.3-3.8.4-6.2v-2.6h.1l.5-.5 3.3-3.5 5.2-5a164 164 0 015-4.8c0 .3-3.1 3.3-4.4 4.8-2.7 2.6-3.8 4-5.5 5.6a44099.2 44099.2 0 00-3.5 3.9v-.3l.1 1.7.1 3.2v2.6l.1 7a42.6 42.6 0 00.1 6.8v4.1c0 2.2.2 1.7.2 3.3v14.8l-1-.8h40.9l-.8.8v-4.2-9.4V29l.1-4.2c-.2-7.2 0-15 0-22.6V.6l.7.6h-5.6C65 1 62.1.9 60 .8l-8.4.1-2-.1h-5.3z"
              clip-rule="evenodd"
            />
            <path fill="#181930" d="M42.6 29.8L30.3 49.7v8.2h40.4L42.6 29.8z" />
            <path
              fill="#F5BD1D"
              stroke="#F5BD1D"
              stroke-linejoin="round"
              d="M44.1 14.4V.6L30.3 14.4H44z"
            />
            <path fill="#F5BD1D" d="M15 29.8L1 43.6V87h40.8V29.8h-27z" />
            <path
              fill="#fff"
              fill-rule="evenodd"
              d="M34.3 48.5c0 .5-.7.4-1.2.5l-1.3.3-.4-.1-1.8.1h-2.9l-1 .2-1.2-.2a5 5 0 00-.6 0H9.5h2.3l.5-.1h.8l.9-.1a4.2 4.2 0 00.9 0h.5l.5-.2H19c.6-.2 1-.1 1.5-.2h1.4a9 9 0 001.8-.2H25l2-.1h.5l3-.2.4.1h.6c0 .2.4.2.7.3.4 0 .8 0 1.1-.2.2 0 .2 0 .3.2h.7zM34.6 57.4c0 .4-.7.4-1.3.5l-1.2.2h-2.2l-1.9.1h-1c-.4 0-.8 0-1 .2l-1.2-.3a5 5 0 00-.7 0h-1l-2.2.1H9.8h1.8l.4-.1h1.4l.9-.2a4.2 4.2 0 00.9 0h.5l.4-.1 3.2-.1c.6-.1 1 0 1.5-.2h1.4a9 9 0 001.8-.1h1.3l2-.2h.5l3-.1h.9c.1.2.5.2.8.3l1-.1.4.1h.7zM34.8 66.2c0 .5-.7.4-1.2.5l-1.3.3-.5-.1c-.7.1-1 0-1.9.2h-3c-.4 0-.7 0-1 .2l-1.3-.3H23l-2.3.1h-3.4a30.1 30.1 0 00-3.7 0h-1.4a7 7 0 01-.5 0H9h3l.4-.1h.4l.9-.1a4.6 4.6 0 001 0h.5c.3-.1.2-.2.5-.2l3.3-.1 1.5-.1 1.4-.1 2-.1 1.2-.1h2.7c1-.2 2-.3 3.1-.3l.4.2.6-.1c0 .2.5.2.8.3.4 0 .7 0 1.1-.2.2 0 .2 0 .3.2h.7zM35 75c0 .5-.6.4-1.2.5-.4.2-.8.3-1.3.3l-.4-.1-1.9.1a6 6 0 00-2 0l-1.1-.1c-.4 0-.7 0-1 .2l-1.2-.3a4 4 0 00-.7 0l-.6-.1h-2.8l-3.4-.1h-.6l-3.1-.2h-1.5l-.4-.1H9h2l.4-.1H13l1-.1a3.5 3.5 0 00.9 0h.6l.4-.1h3.3l1.5-.2h3.5l1.2-.1H28c1-.1 2-.2 3.1-.1l.4.1h.6c0 .2.5.3.8.4.4 0 .8 0 1.2-.2l.2.2h.8z"
              clip-rule="evenodd"
            />
            <path
              fill="#F5BD1D"
              fill-rule="evenodd"
              d="M15 30c-.2-.6 5.1-.5 9-.6l9.5-.4c2 0 1.5.2 3.2.2a277.8 277.8 0 015.7 0l.2.6.1 8.5.1 14.2v8.4c0 3 .1 5.3.3 7.4l-.4 8.8V82l-.2 4.1a29.7 29.7 0 000 1.3.6.6 0 01-.6.5l-2.7.1-16.8.1H1.1a1 1 0 01-1-.9v-3.4-4.2c.3-7.4.2-16-.1-22.6v-4.7c.1-2.8.4-3.8.5-6.2l.1-2.4c0-.2 0-.3.2-.3l.5-.5 3.3-3.6c1.6-1.4 3.4-3.2 5.1-5l5-4.7c.1.5-3 3.4-4.3 4.9C7.7 37 6.6 38.4 5 40c-.7.7-1.2 1.4-1.7 2.2L1.5 44l.1-.4v1.7c0 1.7 0 2.7.2 3.2 0 1.3-.2 1.1-.1 2.6.1 2.1 0 6 .3 6.9a32 32 0 000 6.8V69c0 2.2.3 1.7.3 3.3L2.2 87 1 86l9.3.1 11-.1H32c2.8.2 6.3.2 10 .1l-1 1v-4.2-9.4-15.3-4.1c-.2-7.2 0-15 0-22.6l.2-1.7.8.8-1.4-.1-4.2.1c-.4-.3-3.3-.4-5.6-.5l-8.4.1c-.7 0-1.4 0-2-.2H15z"
              clip-rule="evenodd"
            />
            <path fill="#181930" d="M15 43.6V29.8L1 43.6h13.8z" />
          </svg>

          <p class="c-modal-autos__titulo">Solicitando os autos</p>
        </div>
        <p>
          Os autos do processo são compostos por todos os documentos que
          constituem o processo, é a cópia integral, desde a petição inicial até
          o ponto que se encontra no momento da solicitação. Por um preço
          acessível, você terá acesso a todos os anexos juntados pelos
          envolvidos, como: <strong>petições</strong>,
          <strong>termos de audiências</strong>, <strong>certidões</strong>,
          <strong>ofícios</strong>, <strong>mandados</strong> e
          <strong>sentenças</strong>.
        </p>
      </div>
      <div class="c-modal-autos__condicao">
        <small>
          A cópia dos autos está disponível apenas para os
          <strong>envolvidos ou advogados constituídos</strong> no processo.
        </small>
      </div>
      <p class="form-box -full -checkbox item">
        <input
          id="confirmarEnvolvido"
          v-model="confirmouSerEnvolvido"
          type="checkbox"
          class="field model-link-checkbox"
        />
        <label
          for="confirmarEnvolvido"
          class="label"
          :class="{ erro: erroValidacao }"
        >
          Sou envolvido ou advogado constituído no processo.
        </label>
      </p>
    </div>
    <div slot="footer">
      <button
        id="btnMesclar"
        type="button"
        class="c-button c-button--secondary c-button--center c-modal-autos__botao"
        @click="irParaSolicitacaoDeAutos"
      >
        Continuar
      </button>
    </div>
  </modal>
</template>

<script>
import { subdomainUrl } from "../../utils/url";
export default {
  props: {
    processo: {
      type: String
    },
    campanhaId: {
      type: String
    }
  },
  data() {
    return {
      confirmouSerEnvolvido: false,
      erroValidacao: false
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    irParaSolicitacaoDeAutos() {
      if (!this.confirmouSerEnvolvido) {
        this.erroValidacao = true;
      } else {
        EventBus.$emit("close-modal");
        window.location = subdomainUrl(
          "app",
          `autos/solicitacoes/nova?processo=${this.processo}&campaign_id=${this.campanhaId}`
        );
      }
    }
  }
};
</script>

<style lang="stylus">
.Modal__callToActionAutos
  & .Modal__header
    text-align center
  & .Modal__content
    font-size 1rem
    margin-top 0
    padding 16px 20px
    .Explicacao
      text-align center
      margin-bottom 32px
    .erro
      color red
      font-weight 500
  & .Modal__footer
    margin-top 0 !important
    justify-content center

.c-modal-autos
  &__titulo
    margin-top 24px
    font-size 24px
    font-weight 700
  &__botao
    width 220px
    margin-bottom 16px
  &__icone
    width 140px
    height 140px
  &__condicao
    line-height 1
    margin-bottom 4px

@media (max-width 768px)
  .c-modal-autos
    &__titulo
      font-size 22px
      margin 8px 0 12px
    &__icone
      width 94px
      height 94px
    &__content
      font-size 14px
      margin-bottom 20px
    &__condicao
      margin-bottom 12px

  .Modal__callToActionAutos
    & .Modal__content
      padding 16px 0
</style>
